import {UyapRequest} from "./UyapRequest";

export interface KisiMernisAdresiVarmiTalep {
    tcKimlikNo: any
}

export type KisiMernisAdresiVarmiCevap = boolean | { "errorCode": string, "error": string }

export default class KisiMernisAdresiVarmi extends UyapRequest<KisiMernisAdresiVarmiTalep, KisiMernisAdresiVarmiCevap> {
    delayTime = 1000;

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Kişi MERNİS adresi var mı sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "KisiMernisAdresiVarmi_" + this.talepData.tcKimlikNo
        };
    }

    getMockResponse(): any {
        return true;
        // return {"errorCode":"PRTL_GNL_100073", "error":"Sistemde kayıtlı adres bilgisi bulunamadı. "}
        // return {"errorCode":"PRTL_GNL_10001-61", "error":"Eş zamanlı olarak birden fazla sorgulama yapamazsınız! "}
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'mtsMernisAdresiKontrol_brd.ajx';
    }

    async parse(data: boolean): Promise<KisiMernisAdresiVarmiCevap> {
        return data;
    }

}